export class CommandHistory {
    #undoStack = [];
    #redoStack = [];
    #maxSize;
    constructor(options = {}) {
        const maxSize = options.maxSize ?? 200;
        if (!Number.isInteger(maxSize) || maxSize < 1) {
            throw new RangeError("CommandHistory maxSize must be a positive integer.");
        }
        this.#maxSize = maxSize;
    }
    execute(command) {
        command.execute();
        this.#undoStack.push(command);
        if (this.#undoStack.length > this.#maxSize) {
            this.#undoStack.shift();
        }
        this.#redoStack.length = 0;
    }
    undo() {
        const command = this.#undoStack.pop();
        if (!command) {
            return false;
        }
        command.undo();
        this.#redoStack.push(command);
        return true;
    }
    redo() {
        const command = this.#redoStack.pop();
        if (!command) {
            return false;
        }
        command.execute();
        this.#undoStack.push(command);
        return true;
    }
    clear() {
        this.#undoStack.length = 0;
        this.#redoStack.length = 0;
    }
    get canUndo() {
        return this.#undoStack.length > 0;
    }
    get canRedo() {
        return this.#redoStack.length > 0;
    }
    get undoDepth() {
        return this.#undoStack.length;
    }
    get redoDepth() {
        return this.#redoStack.length;
    }
}
//# sourceMappingURL=history.js.map